import { IMediaImageUrls, TMedia } from "~/entities/media";

export default function findFirstJpegSource(
  gallery?: TMedia[]
): IMediaImageUrls | undefined {
  const foundItem = gallery?.find((galery) => galery?.type === "image");
  return foundItem ? (foundItem as IMediaImageUrls) : undefined;
}
